import React from 'react'

function uniqueElements(array) {
    return array.filter(function (value, index, self) {
        return self.indexOf(value) === index;
    });
}

function renderTimeSlots(timeSlots) {
    const showPrice = uniqueElements(timeSlots.map(slot => slot.price_cents)).length !== 1;

    return timeSlots.map((slot, index) => {
        const {start_time, end_time, price_cents, vehicle_type} = slot;
        const vehicle_name = I18n.t(`cart_summary.vehicle_types.${vehicle_type}`);
        let text;

        if (showPrice) {
            const price = `€${price_cents / 100.0}`;

            text = `${start_time}-${end_time} (${price} ${vehicle_name})`;
        } else {
            text = `${start_time}-${end_time}`;
        }

        return <option key={index} value={index}>{text}</option>;
    });
}

function renderErrors(errors) {
    if (!errors.time_slot) { return false;}

    return errors.time_slot && errors.time_slot.map(function (error, index) {
        return (
          <div key={index}
               className="help-block error">{error}</div>
        )
    });
}


const DeliveryTimeSlotForm = ({errors, onChange, slots, slotIndex}) => {
    return (
        <div className="delivery-address-form order-step">
            <h4>
                {I18n.t('cart_summary.delivery_time')}
            </h4>
            <fieldset>
                <div className="row">
                    <div className="col-sm-12">
                        <div className="form-group">
                            <select name="time_slot"
                                    className="form-control"
                                    value={slotIndex || ''}
                                    onChange={(event) => onChange(event.target.value)}>
                                <option value="">{I18n.t('cart_summary.select_delivery_time')}</option>
                                {renderTimeSlots(slots)}
                            </select>
                            {renderErrors(errors)}
                        </div>
                    </div>
                </div>
            </fieldset>
        </div>
    );
};

export default DeliveryTimeSlotForm;
